'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Parser = undefined;

var _request = require('./request');

var Parser = exports.Parser = {
  prepareCalls: function prepareCalls(Endpoints, settings) {
    var calls = {};

    for (var key in Endpoints) {
      calls[key] = this.run(key, Endpoints[key], settings);
    }
    return calls;
  },
  run: function run(endpoint, endpointSettings, settings) {
    var endpointMethods = {};

    for (var action in endpointSettings.actions) {
      endpointMethods[action] = _request.Requester.bindMethod(endpointSettings.actions[action], settings);
    }

    return endpointMethods;
  }
};